export const IS_TESTING_ENVIRONMENT: boolean = (() => {
  // 1) Local development (build-time env)
  if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
    return true;
  }

  // 2) Detect non-browser environments
  if (typeof window == 'undefined') {
    return false;
  }

  // 3) Browser-based checks (guarded behind window)
  if (typeof window !== 'undefined' && window.location) {
    try {
      const { hostname, search } = window.location;

      // Test pages hosted under a specific hostname
      if (hostname.startsWith('oneaudi-feature-app')) {
        return true;
      }

      // Query parameter environment=development
      if (search) {
        const params = new URLSearchParams(search);
        if (params.get('environment') === 'development') {
          return true;
        }
      }
    } catch {
      // If any URL parsing fails, fall back to other checks
    }
  }

  return false;
})();

export const QA_ONE_GRAPH_URL = 'https://int.onegraph.audi.com/graphql';
export const PROD_ONE_GRAPH_URL = 'https://onegraph.audi.com/graphql';
export const QA_DEALER_SEARCH_URL = 'https://graphql.dev-pss.audi.com';
export const PROD_DEALER_SEARCH_URL = 'https://graphql.pss.audi.com';
